import { DataFromHeaders, HeaderDataList } from '../../types/csv';

export function toCsv<T extends HeaderDataList>({
  columns,
  data,
  fileName,
  reportTitleRows,
}: {
  columns: T;
  data: DataFromHeaders<T>[];
  fileName: string;
  reportTitleRows?: string;
}) {
  const header = columns.map(column => column.label).join(',');
  const body = data
    .map(row =>
      columns
        .map(column => {
          const value = row[column.dataKey as keyof typeof row];
          if (typeof value === 'string') {
            return `"${value.replace(/"/g, '""')}"`;
          }
          return value;
        })
        .join(','),
    )
    .join('\n');

  const titleRows = reportTitleRows ? `${reportTitleRows}\n` : '';
  const csv = `${titleRows}${header}\n${body}`;
  const blob = new Blob([csv], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${fileName}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
